/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable, Injector } from '@angular/core';
import { ObservableList, Alert, ObservableMap, AlertService } from '@typescript-kit/core';
import { ContainerModel, AlertModel } from '@typescript-kit/view';
import { ViewService } from '../util/view-service.util';

@Injectable()
export class AlertContainerViewService extends ViewService<ObservableList<Alert>, ContainerModel> {

  initialize(alertList?: ObservableList<Alert>) {
    super.initialize(alertList || this.alertService.alerts);
  }

  finalize() {
    super.finalize();
  }

  protected createComponentModel(): ContainerModel {
    return new ContainerModel({
      tags: ['kit-alert-container'],
      items: new ObservableMap<AlertModel>(this.createAlertContainerItems())
    });
  }

  protected refreshComponentModel(model: ContainerModel) {
    model.items.setValues(this.createAlertContainerItems(), { exclusive: true });
  }

  private createAlertContainerItems(): AlertModel[] {
    return this.viewModel.toArray().map((alert, index) => this.createAlertModel(alert, index));
  }

  private createAlertModel(alert: Alert, index: number): AlertModel {
    return new AlertModel({
      key: index.toString(),
      kind: alert.kind,
      message: alert.message,
      isClosable: true,
      onSetTimeout: () => this.alertService.setTimeout(alert),
      onClearTimeout: () => this.alertService.clearTimeout(alert),
      onDiscard: () => this.alertService.discard(alert)
    });
  }

}
